import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

/**
 * This hook is responsible for listening to the location hash (via react router)
 * and scrolling to the correct element on the page based on the entry in the URL
 * @returns
 */
export const useScrollToAnchor = () => {
  const location = useLocation();
  const lastHash = useRef("");

  useEffect(() => {
    if (!location.hash) return;
    const targetId = location.hash.slice(1);
    if (!document.getElementById(targetId)) return;
    if (lastHash.current === targetId) return;
    lastHash.current = targetId;

    const headingSectionElement = document.getElementById(targetId);
    if (!headingSectionElement) return;

    headingSectionElement.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
  }, [location.hash]);
};
